import { useMemo, useState } from "react";

import { useCall } from "../state/CallProvider";
import type { Contact } from "../telephony/types";
import { IconPhone } from "./icons";

/** Contacts — the people this agent has spoken with, derived from call history
 *  (deduped by number). In a CRM deployment this would sync from the host's
 *  address book; for now it's a fast redial surface. */
export function Contacts() {
  const { state, dial } = useCall();
  const [q, setQ] = useState("");

  const contacts = useMemo(() => {
    const byNumber = new Map<string, Contact>();
    for (const h of state.history) {
      if (!byNumber.has(h.contact.number)) byNumber.set(h.contact.number, h.contact);
    }
    return [...byNumber.values()].sort((a, b) => (a.name ?? a.number).localeCompare(b.name ?? b.number));
  }, [state.history]);

  const filtered = contacts.filter((c) =>
    !q.trim() || (c.name ?? "").toLowerCase().includes(q.toLowerCase()) || c.number.includes(q));

  return (
    <div className="ct">
      <input className="ct-search" value={q} placeholder="Search contacts" onChange={(e) => setQ(e.target.value)} />
      {filtered.length === 0 ? (
        <div className="list-empty">No contacts yet — they build up from your calls.</div>
      ) : (
        <div className="list">
          {filtered.map((c) => (
            <div key={c.number} className="li" onClick={() => void dial(c)} title="Call">
              <span className="ct-avatar">{(c.name ?? c.number).slice(0, 1).toUpperCase()}</span>
              <div className="li-main">
                <div className="li-name">{c.name ?? c.number}</div>
                {c.name && <div className="li-sub">{c.number}</div>}
              </div>
              <span className="ct-call"><IconPhone size={16} /></span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
